<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <bread-crumb></bread-crumb>
            <div class="a-flex-rfsc">
                <el-button type="primary" @click="handleToPay" v-if="detail.payStatus != 2">付款</el-button>
                <el-button type="primary" @click="handleSetPZ">编号管理</el-button>
                <el-button plain type="danger" @click="handleDel">删除</el-button>
            </div>
        </div>
        <div class="projectDetail a-flex-cfsfs" style="align-items: stretch;">
            <div class="projectDetail-top a-flex-csbfs ">
                <div class="a-flex-rfsfs">
                    <span class="a-fs-16 a-fw-700">账单编号：{{ detail.id || '-' }}</span>
                </div>
                <div class="a-flex-rfsfs a-flex-wrap a-w-100">
                    <div class="projectDetail-top-item a-flex-rfsc">
                        <div>电费项目</div>
                        <el-popover
                            placement="bottom-start"
                            title="电费项目"
                            width="400"
                            trigger="hover">
                            <div class="a-flex-cfsfs">
                                <span class="a-fs-13 a-mt-10" v-for="(item,index) in detail.projectNameList" :key="index">{{ index+1 }}. {{ item }}</span>
                            </div>
                            <div slot="reference" class="textOver1" style="width: 300px">{{ detail.projectNameListStr }}</div>
                        </el-popover>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>缴费状态</div>
                        <span>{{ detail.payStatus | initDic(payStatusDic) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>账单类型</div>
                        <span>{{ detail.billType | initDic(billTypeDic) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>付款方式</div>
                        <span v-if="detail.billType == 1 || detail.billType == 3">{{ detail.chargeFeeType | initDic(chargeFeeTypeDic) }}</span>
                        <span v-else>-</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>电费金额</div>
                        <span>￥{{ util.numFormat(detail.electricFee || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>服务费</div>
                        <span>￥{{ util.numFormat(detail.serviceFee || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>应付合计</div>
                        <span>￥{{ util.numFormat(detail.totalPay || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>已付合计</div>
                        <span>￥{{ util.numFormat(detail.payAmount || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>上次抄表时间</div>
                        <span>{{ detail.billDateStart || '-' }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>本次抄表时间</div>
                        <span>{{ detail.billDate || '-' }}</span>
                    </div>
                    <!-- <div class="projectDetail-top-item">
                        <div>单价</div>
                        <span>￥{{ util.numFormat5(detail.unitPrice || 0) }}</span>
                    </div> -->
                    <div class="projectDetail-top-item">
                        <div>账单单价</div>
                        <span>￥{{ util.numFormat5(detail.billUnitPrice || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>应结算度数</div>
                        <span>{{ detail.totalEnergy || 0 }}kwh</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>预估度数</div>
                        <span>{{ detail.predictEnergy || 0 }}kwh</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>区间电费</div>
                        <span>￥{{ util.numFormat(detail.totalIntervalFee || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>区间收益</div>
                        <span>￥{{ util.numFormat(detail.totalProfit || 0) }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>区间电费占比</div>
                        <span>{{ util.numFormat(detail.ratio || 0) }}%</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>凭证号</div>
                        <span>{{ detail.voucherNumber || '-' }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>请款单号</div>
                        <span>{{ detail.payRollNumber || '-' }}</span>
                    </div>
                    <div class="projectDetail-top-item">
                        <div>备注</div>
                        <el-tooltip placement="top">
                            <div slot="content" style="max-width: 300px">{{ detail.remark || '-' }}</div>
                            <span class="textOver1">{{ detail.remark || '-' }}</span>
                        </el-tooltip>
                        <i class="el-icon-edit a-fs-18 a-c-blue a-ml-10 a-fw-700 font-point" @click="handleEditRemark"></i>
                    </div>
                </div>
                <el-tabs class="a-mt-16 devicetabs" v-model="activeName">
                    <el-tab-pane label="抄表详情" name="0"></el-tab-pane>
                    <el-tab-pane label="服务费详情" name="2"></el-tab-pane>
                    <el-tab-pane label="付款记录" name="1"></el-tab-pane>
                    <el-tab-pane label="审核记录" name="3"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="tab-content a-flex-1">
                <electric-charge v-if="activeName == '0'" :tabledata='detail.billAmmeterRecordResultList'></electric-charge>
                <operate-list v-if="activeName == '1'" :details='detail' :tabledata='detail.billPayRecordList' @change="handleChangeOperate"></operate-list>
                <service-charge v-if="activeName == '2'" :tabledata='detail.billAmmeterServiceResultList'></service-charge>
                <bill-audit-history v-if="activeName == '3'"></bill-audit-history>
            </div>
        </div>
        <electric-bill-pay ref="payBill" @change="handlePaySuccess"></electric-bill-pay>
        <bill-num-edit ref="billNumEdit" @change="handlePaySuccess"></bill-num-edit>
    </div>
</template>
<script>

import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex';
import util from '../../../src/utils/util'
import billAuditHistory from './bill-info-child/bill-audit-history.vue';
import BillNumEdit from './bill-info-child/bill-num-edit.vue';
import ElectricCharge from './bill-info-child/electric-charge.vue'
import OperateList from './bill-info-child/operate-list.vue';
import ServiceCharge from './bill-info-child/service-charge.vue';
import ElectricBillPay from './child/electric-bill-pay.vue'
export default {
    components: { 
        ElectricCharge,
        OperateList,
        ElectricBillPay,
        BillNumEdit,
        ServiceCharge,
        billAuditHistory
    },
    data() {
        
        return {
            util: util,
            activeName: '0',
            id: '',
            detail: {},
            payStatusDic: [],
            chargeFeeTypeDic: [],
            billTypeDic: [{
                label: '电费账单',
                value: '1'
            },{
                label: '服务费账单',
                value: '2'
            },{
                label: '电费+服务费账单',
                value: '3'
            }]
        }
    },
    created() {
        this.id = this.$route.query.id
        this.$getDic('billPayStatus','select').then(res=>{ this.payStatusDic = res; })
        this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        if(this.id)
        this.getDetail()
    },
    mounted() {

    },
    computed: {
        ...mapState({
            info: state => state.user.user
        })
    },
    methods: {
        getDetail() {
            this.$Axios._get({
                url: this.$Config.apiUrl.electricBillRecordInfo,
                params: {
                    billId: this.id
                }
            }).then(({data}) => {
                let projectNameList = data.projectName ? [...new Set(JSON.parse(data.projectName))] : []
                this.detail = {
                    ...data,
                    projectNameList: projectNameList,
                    projectNameListStr: projectNameList.join('、'),
                    billPayRecordList: data.billPayRecordList.map(item=>{
                        return {
                            ...item,
                            images: item.images ? JSON.parse(item.images) : [],
                            readOnlyImages: item.images ? JSON.parse(item.images).map(item=>{ return { url: item, name: item } }) : []
                        }
                    })
                }
                if(this.detail.billAmmeterServiceResultList && this.detail.billAmmeterServiceResultList.length) {
                    // 先按电表聚合每块电表的应付电费合计
                    let needPayAmountObjByAmmeter = {}, needPayAmountTotal = 0
                    this.detail.billAmmeterServiceResultList.map(item=>{
                        needPayAmountObjByAmmeter[item.ammeterId] = item.needPayAmount
                    })

                    for (const key in needPayAmountObjByAmmeter) {
                        const needPayAmount = needPayAmountObjByAmmeter[key];
                        needPayAmountTotal = this.$decimal.decimal_add(needPayAmountTotal, needPayAmount)
                    }

                    this.detail.billAmmeterServiceResultList = this.detail.billAmmeterServiceResultList.map(item=>{
                        return {
                            ...item,
                            totalProfit: this.detail.totalProfit,
                            needPayAmountTotal: needPayAmountTotal
                        }
                    })
                }
                if(data.billType == 2) {
                    this.activeName = '1'
                }
            })
        },
        handleToPay () {
            this.$refs['payBill'].billInfo = this.detail
            this.$refs['payBill'].dialogVisible = true
        },
        handlePaySuccess () {
            this.getDetail()
        },
        handleSetPZ () {
            this.$refs["billNumEdit"].form.voucherNumber = this.detail.voucherNumber ? this.detail.voucherNumber : ''
            this.$refs["billNumEdit"].form.payRollNumber = this.detail.payRollNumber ? this.detail.payRollNumber : ''
            this.$refs["billNumEdit"].idList = [this.id]
            this.$refs["billNumEdit"].dialogVisible = true
        },
        handleDel () {
            this.$confirm('是否确认删除？','温馨提示')
            .then(_=>{
                this.$Axios._post({
                    url: this.$Config.apiUrl.electricBillDelete,
                    method: "post",
                    params: {
                        billId: this.id
                    }
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        this.$message.success('操作成功')
                        this.$router.back()
                        this.$store.dispatch("delView", this.$route);
                    } else {
                        this.$message.error(res.result.message)
                    }
                })
                .catch(err=>{

                })
            })
            .catch(_=>{})
        },
        handleEditRemark (datas) {
            this.$prompt('', '请输入备注', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputValue: this.detail.remark || '',
                inputValidator: (val)=>{
                    if(val.length > 500) {
                        return '最多可输入500字'
                    }
                }
            }).then(({ value }) => {
                this.$Axios._post({
                    url: this.$Config.apiUrl.electricBillUpdateRemark,
                    params: {
                        "billId": this.id,
                        "remark": value
                    },
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getDetail()
                })
                .catch((error) => {});
            }).catch(() => {});
        },
        handleChangeOperate () {
            this.getDetail()
        }
    }
}
</script>
<style lang="scss" scoped>
.projectDetail {
    font-size: 14px;
    height: 100%;
    overflow-y: auto;
    
    >div {
        border-radius: 4px;
    }

    &-box {
        border-radius: 4px;
        background: #fff;
    }
    .reject-content{
        background-color: #fef0f0;
        border: 1px solid #fde2e2;
        color: #f56c6c;
        border-radius: 4px;
        padding: 10px;
    }
    &-top {
        background: #fff;
        padding: 24px 24px 0;
        position: relative;
        &-item {
            display: flex;
            flex-direction: row;
            width: 480px;
            margin-top: 16px;
            font-size: 14px;
            line-height: 22px;

            >div:nth-child(1) {
                width: 100px;
                min-width: 100px;
                color: #797979;
            }

            span {
                margin-left: 16px;
            }
        }
    }

    .tab-content{
        background: #fff;
        padding: 24px;
        position: relative;
        margin-top: 11px;
    }

    /deep/ .el-tabs__item {
        // color: #007aff;
        font-size: 14px;
    }

    /deep/ .el-tabs__item.is-active {
        color: #007AFF;
        font-weight: bold;
    }

    /deep/ .el-tabs__nav-wrap::after {
        background: none !important;
    }

    /deep/ .el-tabs__header {
        padding: 15px 0 0;
        background: #fff;
    }

    .zdxx {
        background: #fff;
        padding: 24px;

        &-table {
            // margin-top: -24px;
            background: #fff;
            width: 100%;
        }
    }
}



/deep/ .el-date-editor--daterange {
    margin: 0;
    margin-top: -12px;
    margin-bottom: -18px;
}

.zdxx-table {
    padding: 24px;
    background: #fff;
}

/deep/ .projectDetail-top-tabs {
    margin-top: 30px;
}

/deep/ .el-table thead {
    color: #606366 !important;
}

/deep/ .el-table {
    color: #303133
}
</style>